import React, { useEffect, useRef, useState } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { Sun, Shield, Zap } from 'lucide-react';

gsap.registerPlugin(ScrollTrigger);

const ZebreBlinds = () => {

    const whatWeOfferRef = useRef(null); 
      
        const scrollToSection = () => {
          if (whatWeOfferRef.current) {
            whatWeOfferRef.current.scrollIntoView({ behavior: "smooth" });
          }
        };
  const features = [
    {
      title: "Light Control",
      description:
        "Easily adjust light levels with dual-layered fabrics for perfect ambiance and privacy.",
    },
    {
      title: "Modern Design",
      description:
        "Sleek and elegant zebra blinds complement any home decor style effortlessly.",
    },
    {
      title: "Durability",
      description:
        "Crafted from high-quality materials, ensuring long-lasting performance and reliability.",
    },
    {
      title: "UV Protection",
      description:
        "Block harmful UV rays while still allowing natural light into your space.",
    },
    {
      title: "Energy Savings",
      description:
        "Improve insulation and reduce energy costs with light-filtering and blackout options.",
    },
    {
      title: "Custom Fit",
      description:
        "Tailored to your window dimensions, ensuring a perfect fit for any room.",
    },
  ];
  
  
    const [activeIndex, setActiveIndex] = useState(null);
  
    const toggleFAQ = (index) => {
      setActiveIndex(activeIndex === index ? null : index);
    };
  
    return (
      <div className=' font-playfair'>
<section 
  className="text-center object-left lg:object-cover h-screen flex flex-col  pt-40 md:pt-40 lg:pl-32 "
  style={{ backgroundImage: "url('images/zebra.webp')" }}
>
  <div className="px-8 sm:px-16 lg:px-24">
    <h1 className="text-6xl md:text-8xl 2xl:text-[140px] font-semibold text-[#ffff] font-Montserrat uppercase  mb-4  lg:text-8xl ">
    zebra 
    </h1>
    <h1 className="text-6xl md:text-8xl 2xl:text-[140px] font-semibold text-[#ffff] font-Montserrat uppercase  mb-4  lg:text-8xl ">
      Blinds
    </h1>
  </div>

  {/* Button positioned below the text */}
  <div className="mt-4 2xl:mt-6 flex justify-center   ">
    <button onClick={scrollToSection} className="text-black bg-[#fff] 2xltext-xl w-40 2xl:w-48 px-6 py-2">
      LEARN MORE
    </button>
  </div>
</section>

        <div className="flex flex-col xl:gap-20 xl:px-20 2xl:px-32">
        {/* Header Section */}
        <header className="text-center pt-20">
          <h1 ref={whatWeOfferRef} className="text-4xl md:text-5xl lg:text-8xl font-extrabold text-gray-900 mb-8 ">Zebra Blinds</h1>
        </header>

        {/* About Motorized Blinds */}
        <section className="mb-16 px-3 flex  flex-col lg:flex-row gap-6 xl:gap-20 justify-between items-center">
          <h2 className="text-2xl md:text-6xl 2xl:text-8xl font-semibold text-gray-800  text-center">What are Zebra Blinds?</h2>
          <p className=" text-xl md:text-2xl xl:text-3xl 2xl:text-4xl text-gray-700 max-w-lg lg:max-w-lg xl:max-w-xl text-justify">
          Zebra blinds are window treatments that can be controlled automatically via a motor, 
              providing enhanced convenience, privacy, and energy efficiency. Whether you use a remote, 
              a mobile app, or integrate with a smart home system, Zebra blinds offer seamless operation 
              to suit your needs.
          </p>
        </section>

        {/* Benefits of Motorized Blinds */}
        <section className="mb-16 px-3 flex flex-col lg:flex-row gap-10 md:gap-20 justify-between items-center">
          {/* < className=" text-xl text-gray-700"> */}
            <p className="text-xl md:text-2xl xl:text-3xl 2xl:text-4xl text-gray-700 max-w-lg lg:max-w-lg xl:max-w-xl text-justify">
            Easily control your blinds with remote, app, or voice commands
                Program blinds to open and close based on time of day, 
                helping to regulate temperature and reduce energy costs
                Adjust blinds for privacy with ease, without needing to manually adjust them
             Integrate Zebra blinds with your smart home system for seamless control.
            </p>

          <h2 className="text-4xl md:text-6xl 2xl:text-8xl font-semibold text-gray-800 text-center">Benefits of Zebra Blinds</h2>

        </section>

        {/* How Motorized Blinds Work */}
        <section className="xl:mb-16 px-3 flex flex-col lg:flex-row gap-5 xl:gap-20 justify-between items-center">
          <h2 className="text-3xl md:text-6xl 2xl:text-8xl font-semibold text-gray-800 mb-4 text-center">How Do Zebra Blinds Work?</h2>
          <p className="text-xl md:text-2xl xl:text-3xl 2xl:text-4xl text-gray-700 max-w-lg lg:max-w-lg xl:max-w-xl text-justify ">
          Zebra blinds are powered by an electric motor that is built into the blinds mechanism. 
              This motor is controlled via various methods such as a remote control, a mobile app, or 
              voice assistants like Alexa or Google Assistant. You can also set schedules, adjust the blinds 
              based on the time of day, or integrate them with your home automation system for smart control. 
              The operation is smooth, quiet, and energy-efficient.
          </p>
        </section>
        </div>

      {/* Content Section */}
  <section className="py-16 px-2 md:px-6">
  <h2 className="text-3xl md:text-5xl lg:text-7xl font-bold text-center mb-10 md:mb-20 ">
  Transform Your Space with <br/>Zebra Blinds
  </h2>
  <div className="flex flex-col gap-20 xl:gap-40">
    {/* Benefit 1 */}
    <div className="flex flex-col lg:flex-row gap-20 md:gap-5 items-center justify-arround">
      <div className="w-full max-w-xl xl:max-w-3xl mx-auto">
        <h3 className="text-2xl md:text-5xl xl:text-6xl font-medium mb-8">Effortless Morning Comfort</h3>
        <p className="text-gray-600 text-xl  md:text-2xl xl:text-4xl text-justify">
        Start your day seamlessly with Zebra blinds that let in natural light at the perfect time. Wake up to a gradual opening of your blinds, mimicking a gentle sunrise. 
        It’s a refreshing way to begin your day, helping you feel energized and ready to take on whatever lies ahead.
        </p>
      </div>
      <div className="w-full ">
        <img
         className="mx-auto w-full md:w-3/4 xl:w-3/4 h-[300px] md:h-[400px] lg:h-[500px] object-fit"
          src="images/zebra.webp"
          alt="Effortless Morning Comfort"
        />
      </div>
    </div>

    {/* Benefit 2 */}
    <div className="flex flex-col lg:flex-row-reverse gap-20 md:gap-5 items-center justify-between">
      <div className="w-full  max-w-xl xl:max-w-3xl mx-auto">
        <h3 className="text-2xl md:text-5xl xl:text-6xl font-medium mb-8 text-center">Customized Comfort Throughout the Day</h3>
        <p className="text-gray-600 text-xl md:text-2xl xl:text-3xl text-justify">
        Whether it’s a bright sunny afternoon or a cozy rainy day, Zebra blinds let you control the amount of light in your space with ease. 
            Adjust the settings to create the perfect ambiance for working, relaxing, or entertaining, all at the touch of a button.
        </p>
      </div>
      <div className="w-full ">
        <img
         className="mx-auto w-full md:w-3/4 xl:w-3/4 h-[300px] md:h-[400px] lg:h-[500px] object-fit"
          src="images/zebra3.webp"
          alt="Customized Comfort Throughout the Day"
        />
      </div>
    </div>

    {/* Benefit 3 */}
    <div className="flex flex-col lg:flex-row gap-20 md:gap-5 items-center justify-between">
      <div className="w-full max-w-xl xl:max-w-3xl mx-auto">
        <h3 className="text-2xl md:text-5xl xl:text-6xl font-medium mb-8 text-center">Evening Elegance</h3>
        <p className="text-gray-600 text-xl md:text-2xl xl:text-3xl text-justify">
        Create the perfect evening atmosphere with blinds that adjust effortlessly to your desired level of privacy and light. 
        Whether you want a dim, cozy environment for relaxation or a brighter setting for social gatherings, Zebra blinds offer versatility for any occasion.
        </p>
      </div>
      <div className="w-full ">
        <img
        className="mx-auto w-full md:w-3/4 xl:w-3/4 h-[300px] md:h-[400px] lg:h-[500px] object-fit"
          src="images/zebra1.webp"
          alt="Evening Elegance"
        />
      </div>
    </div>
  </div>
</section>
  
          {/* Features */}
       
          <section className="mb-16 bg-white p-8  max-w-6xl mx-auto xl:pt-20 font-playfair">
        <h2 className="text-3xl md:text-6xl text-center font-semibold text-gray-800 mb-20">
          Key Features of Zebra Blinds
        </h2>
        <div>
          {features.map((feature, index) => (
            <div
              key={index}
              className="border-b border-gray-400 p-3 mb-4 "
            >
              <div
                className="flex justify-between items-center cursor-pointer"
                onClick={() => toggleFAQ(index)}
              >
                <h3 className="text-xl md:text-4xl font-semibold text-gray-800 mb-6">
                  {feature.title}
                </h3>
                <button
                  className="text-xl md:text-4xl font-bold text-gray-600"
                  aria-label="Toggle FAQ"
                >
                  {activeIndex === index ? "-" : "+"}
                </button>
              </div>
              {activeIndex === index && (
                <p className="text-gray-600 mt-2 text-base md:text-2xl">{feature.description}</p>
              )}
            </div>
          ))}
        </div>
      </section>
        
  
  
          <section className="relative bg-cover bg-center py-24 " style={{ backgroundImage: "url('images/landing.png') " }}>
          <div className="absolute inset-0 bg-black bg-opacity-50"></div>
          <div className="relative z-10 container mx-auto text-center text-white px-6">
            <h2 className="text-4xl md:text-5xl font-bold mb-6">Ready to Experience Zebra Blinds?</h2>
            <p className="text-lg md:text-xl mb-8">
            Zebra blinds are the perfect solution to add both style and convenience to your home. 
              Whether you’re looking for more comfort, energy efficiency, or smart home integration, 
              Zebra blinds can help enhance your living space.
            </p>
            <a
              href="/contact"
              className="inline-block bg-[#ac9b82] text-white font-semibold font-mono px-8 py-3 uppercase shadow-lg hover:bg-[#9e7f52] transition duration-300"
            >
              Request Your Free Quote
            </a>
          </div>
        </section>
      </div>
  );
};

export default ZebreBlinds;